module.exports = __webpack_public_path__ + "static/media/login_logo.45fa4d2b.png";